<template>
  <header
    class="curation-header"
    :class="{
      'page-hina': isHina,
      'page-jps': isJps,
    }"
  >
    <div
      class="representative-image generated-4"
      v-if="curation.image"
      @click="showImageModal()"
    >
      <UiImageSelection :image="curation.image" :info="true" :fullsize="true" />
      <CurationModal ref="curationModal" />
    </div>
    <BaseSectionContainer
      tag="div"
      size="middle"
      class="title-area"
    >
      <h1
        class="jps-curation-title jps-page-title"
      >
        {{ ls(curation.title) }}
      </h1>
      <p class="jps-curation-yomi jps-page-title-yomi" v-if="isJa" aria-hidden="true">
        {{ curation.title.yomi }}
      </p>
      <p class="jps-curation-summary is-size-6-desktop is-size-7-touch">
        {{ ls(curation.summary) }}
      </p>
      <div class="jps-tag-list">
        <BaseLink
          v-for="tag in curation.tag"
          :to="searchLink(tag)"
          :key="tag.id"
        >
          <UiTagSpan :tag-field="tag" />
        </BaseLink>
      </div>
      <div class="jps-interactions" v-if="!nointeract">
        <UiInteractPanel
          type="curation"
          :data="curation"
          class="jps-card-icon"
        />
      </div>
    </BaseSectionContainer>
  </header>
</template>

<script lang="ts" setup>
import type { CurationModal } from '#components'

const { ls, isJa } = useI18n()
const { compImageSelection } = useImageSelection()
const { imageSelection2ModalInfo } = useCurationModal()
const { isHina, isJps } = useServiceType()

interface Props {
  nointeract: boolean
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {
})

const curationModal = ref<InstanceType<typeof CurationModal>>()
const showImageModal = async () => {
  try {
    await curationModal.value.openAwait({
      info: imageSelection2ModalInfo(compImageSelection(props.curation.image))
    },
    {
      animation: 'slideY'
    })
  } catch (cancel) {}
}

const searchLink = (tag: TagField) => {
  return `/gallery?csid=${systemGallerySearchId()}&f-topic=${tag.id}`
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-header {
  @include typo-paragraph();
  .representative-image {
    width: 100%;
    height: 56.25vw;
    min-height: 210px;
    max-height: 512px;
    text-align: center;
    aspect-ratio: 16 / 9;

    @include is-tablet {
      aspect-ratio: auto;
    }

    .jps-image-selection {
      background: $black;
    }
  }
  /* mobileの場合には16:9で固定 */
  .title-area {
    //@include global-width-strict();
    margin-top: 3rem;
    margin-bottom: 3rem;
    @include is-mobile {
      margin: 1rem 0;
    }

    .front {
      z-index: 100;
    }
    .title,
    .subtitle {
      color: $white;
      text-align: center;
    }
    .title {
      margin-top: 2rem;
      margin-bottom: 3rem;
    }
    .sub {
      padding: 0.5rem;
    }
    .jps-curation-summary {
      margin: 1rem 0;
    }
    .jps-tag-list {
      line-height: 100%;
    }
    .jps-interactions {
      .jps-interact-panel {
        justify-content: center;
      }
    }
  }
}
</style>
